import state from './state'
import mutations from './mutations'
import actions from './actions'

export const config = {
  namespaced: true,
  actions,
  state,
  mutations
}
